(function () {
  'use strict';

  if (window.MBProductCardSliderInit) return;
  window.MBProductCardSliderInit = true;

  function setIndex(card, nextIndex) {
    var carousel = card.querySelector('.mb-product-card__carousel');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.mb-product-card__slide');
    var count = slides.length;
    if (!count) return;

    var current = parseInt(carousel.getAttribute('data-index') || '0', 10);
    var idx = ((nextIndex % count) + count) % count;

    if (idx === current) return;

    carousel.setAttribute('data-index', String(idx));
    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === idx);
    });

    var progress = card.querySelector('.mb-product-card__progress');
    if (progress) {
      var pct = ((idx + 1) / count) * 100;
      progress.style.setProperty('--p', pct + '%');
    }
  }

  function bindArrows(card) {
    if (card.__arrowsBound) return;
    card.__arrowsBound = true;

    var prev = card.querySelector('.mb-product-card__nav--prev');
    var next = card.querySelector('.mb-product-card__nav--next');
    if (!prev && !next) return;

    function handler(dir) {
      var carousel = card.querySelector('.mb-product-card__carousel');
      if (!carousel) return;
      var current = parseInt(carousel.getAttribute('data-index') || '0', 10);
      setIndex(card, current + dir);
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        handler(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        handler(1);
      });
    }
  }

  function addSwipe(card) {
    var area = card.querySelector('.mb-product-card__carousel');
    if (!area || card.__hasSwipe) return;
    card.__hasSwipe = true;

    var startX = null;

    area.addEventListener('touchstart', function (ev) {
      if (!ev.touches || !ev.touches.length) return;
      startX = ev.touches[0].clientX;
    }, { passive: true });

    area.addEventListener('touchend', function (ev) {
      if (startX == null) return;
      var endX = ev.changedTouches[0].clientX;
      var dx = endX - startX;
      startX = null;

      if (Math.abs(dx) > 30) {
        var dir = dx < 0 ? 1 : -1;
        var carousel = card.querySelector('.mb-product-card__carousel');
        if (!carousel) return;
        var current = parseInt(carousel.getAttribute('data-index') || '0', 10);
        setIndex(card, current + dir);
        ev.preventDefault();
      }
    }, { passive: false });
  }

  function initCard(card) {
    if (card.__initialized) return;
    card.__initialized = true;

    var carousel = card.querySelector('.mb-product-card__carousel');
    if (carousel) {
      var slides = carousel.querySelectorAll('.mb-product-card__slide');
      var count = slides.length;
      var progress = card.querySelector('.mb-product-card__progress');
      if (progress && count) {
        var pct = (1 / count) * 100;
        progress.style.setProperty('--p', pct + '%');
      }
    }

    bindArrows(card);
    addSwipe(card);
  }

  function initCards(root) {
    (root || document).querySelectorAll('.mb-product-card').forEach(initCard);
  }

  // Primo giro
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCards(); });
  } else {
    initCards();
  }

  // Supporto a contenuti inseriti dopo (recommendations, filtri, ajax)
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      if (!added) continue;

      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node && node.nodeType === 1) {
          if (node.matches && node.matches('.mb-product-card')) {
            initCard(node);
          } else if (node.querySelector) {
            var found = node.querySelector('.mb-product-card');
            if (found) initCards(node);
          }
        }
      }
    }
  });
  obs.observe(document.body, { subtree: true, childList: true });

  // Hook extra su eventi Shopify (sezione ricaricata)
  document.addEventListener('shopify:section:load', function (e) {
    initCards(e.target);
  });

})();
